import React from 'react';

const accreditationStatus = {
  NOT_ACCREDITED: 'Not accredited',
  ACCREDITED: 'Accredited',
};

// eslint-disable-next-line import/prefer-default-export
export const AccreditedField = ({ source, record }) => (
  <span>{accreditationStatus[record[source]]}</span>
);




// WEBPACK FOOTER //
// ./src/components/ExternalOfferOrder/CustomExternalOfferOrderFields.js